<div class="actions-container" *ngIf="selectedThreadIds.length > 0">
    <div class="close-padding">
        <button cll-icon-button (click)="onClearClicked()">
            <cll-icon>close</cll-icon>
        </button>
    </div>
    <div>
        <span class="button-text">{{selectedThreadIds.length}} items selected</span>
    </div>
    <div>
        <div class="actions-seperator">

        </div>
    </div>
    <div>
        <button cll-button (click)="readThreads()">
            <cll-icon>drafts</cll-icon>
            Mark as 'Read'
        </button>
    </div>
    <div>
        <button cll-button (click)="unReadThreads()">
            <cll-icon>mail</cll-icon>
            Mark as 'Unread'
        </button>
    </div>
    <div>
        <button cll-button (click)="deleteThreads()">
            <cll-icon>delete</cll-icon>
            Delete
        </button>
    </div>
</div>